import React, { ReactNode, useEffect, useReducer } from "react";
import { SrmAuthenticationContextReducer } from "./srm-authentication-context-reducer";
import { defaultSrmAuthenticationContext, SrmAuthenticationContext } from "./srm-authentication-context";
import { SrmSsoAuthenticationService } from "./srm-sso-authentication-service";
import { SrmAuthenticationScreen } from "./srm-authentication-screen";

export const SrmAuthenticationContextProvider = ({ children }: { children: ReactNode}) => {
    const [authenticationContext, authenticationContextDispatcher] =
        useReducer(SrmAuthenticationContextReducer, defaultSrmAuthenticationContext);

    useEffect(() => {
        (async () => {
            await SrmSsoAuthenticationService.getInstance()
                .initialize(handleLoginSuccess, handleLoginFailed);
        })();
    }, []);

    const handleLoginSuccess = (userName: string, dropApiToken: string) => {
        authenticationContextDispatcher({
            action: "login",
            userName,
            dropApiToken,
            getTokenFn: () => dropApiToken,
            onLogoutCallback: () => SrmSsoAuthenticationService.getInstance().logout(handleLogoutSuccess),
        });
    };

    const handleLogoutSuccess = (authenticationUrl: string) => {
        authenticationContextDispatcher({
            action: "logout",
            onLoginCallback: () => {
                if (authenticationUrl) {
                    window.location.href = authenticationUrl;
                }
            },
        });
    };

    const handleLoginFailed = () => {
        authenticationContextDispatcher({
            action: "loginFailed",
        });
    };

    return <SrmAuthenticationContext.Provider value={authenticationContext}>
        {authenticationContext.isAuthenticated ?
            children :
            <SrmAuthenticationScreen />}
    </SrmAuthenticationContext.Provider>;
};
